export default "__VITE_ASSET__BGYFwprX__"